export default __webpack_public_path__ + "static/media/Javascript.5731a2f9.jpg";